require('./stylesheets/households.scss');


angular.module('pages.households', [])
	.config(config);

config.$inject = ['$stateProvider'];
function config($stateProvider) {
	$stateProvider
		.state('pages.households', {
			url: 'households',
			template: require('./templates/index.html'),
			controller: require('./controllers/households'),
			data: {
				iframe: true,
				breadcrumbs: "HOUSEHOLDS.TITLE"
			},
			params: {
				subscribe: null,
				housholdID: null
			},
			pageTrack: '/households'
		});
}

module.exports = 'pages.households';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/households/index.js
 ** module id = 263
 ** module chunks = 1
 **/